export class Rol {
    constructor(rolState) {
        this.rolState = rolState;
    }
    get id() {
        return this.rolState.id;
    }
    get level() {
        return this.rolState.level;
    }
    get name() {
        return this.rolState.name;
    }
    get constant_name() {
        return this.rolState.constant_name;
    }
    get description() {
        return this.rolState.description;
    }
    getState() {
        return this.rolState;
    }
}
